module.exports = __webpack_public_path__ + "static/img/237.b3a9bdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200513/237.jpg
// module id = M092
// module chunks = 0